module.exports = __webpack_public_path__ + "static/media/Path 18781Active.a639f356.svg";